import {
  DEFAULT_SELECTED_INSURANCE_ISSUER_QUERY,
  FEATURED_DATA_QUERY,
  AUTOCOMPLETE_DATA_QUERY,
} from './GlobalInsuranceIssuerSelectWithData';
import InsuranceIssuerSelectWithoutData from './InsuranceIssuerSelect';
import InsuranceIssuerSelectWithData, {
  PROVIDER_INSURANCE_COVERAGE_QUERY,
} from './InsuranceIssuerSelectWithData';

export {
  InsuranceIssuerSelectWithoutData,
  DEFAULT_SELECTED_INSURANCE_ISSUER_QUERY,
  FEATURED_DATA_QUERY,
  AUTOCOMPLETE_DATA_QUERY,
  PROVIDER_INSURANCE_COVERAGE_QUERY,
};

export default InsuranceIssuerSelectWithData;
